import { render } from "./Coordinacion.vue?vue&type=template&id=7c580ebc"
import script from "./Coordinacion.vue?vue&type=script&lang=js"
export * from "./Coordinacion.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/helados_admin_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__